/* @flow */

import xhr from '../../utils/Ajax';
import applyLoading from '../../utils/apply-loading';

const gravarCookie = (token: string, nivel: string) =>
    xhr.post('/gravar-cookie', { token, nivel })
    .then(() => window.location.reload());

export default applyLoading(gravarCookie);



// WEBPACK FOOTER //
// ./app/admin/login/gravar-cookie.js